var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "d-flex flex-column justify-content-center" },
    [
      _vm.validateMfaCode
        ? _c(
            "b-col",
            [
              _c(
                "b-row",
                { staticClass: "d-flex flex-column justify-content-center" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "text-center bold" }, [
                        _c("h5", [_vm._v(_vm._s(_vm.$t("account.enterCode")))]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.codeDestination) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mx-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "d-flex flex-column align-items-left" },
                        [
                          _c("material-input", {
                            attrs: {
                              label: _vm.$t("account.enterCode"),
                              "required-indicator": "",
                            },
                            model: {
                              value: _vm.mfaCode,
                              callback: function ($$v) {
                                _vm.mfaCode = $$v
                              },
                              expression: "mfaCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("account.didNotReceiveCode")) +
                            "\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticClass:
                              "bold underline text-primary d-block d-md-inline",
                            staticStyle: { cursor: "pointer" },
                            on: { click: _vm.reSendCode },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("account.resendCode")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMfaRequiredAndNotEnabled
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.trustThisDeviceQuestion")
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      !_vm.isMfaRequiredAndNotEnabled
                        ? _c("b-col", { attrs: { cols: "12" } }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("account.trustThisDeviceInfo")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMfaRequiredAndNotEnabled
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex justify-content-start align-items-center",
                              attrs: { cols: "1" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isTrustedDevice,
                                    expression: "isTrustedDevice",
                                  },
                                ],
                                attrs: {
                                  id: "trustedDevice",
                                  type: "checkbox",
                                  name: "trustedDevice",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.isTrustedDevice)
                                    ? _vm._i(_vm.isTrustedDevice, null) > -1
                                    : _vm.isTrustedDevice,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isTrustedDevice,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isTrustedDevice = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isTrustedDevice = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isTrustedDevice = $$c
                                    }
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "pt-1 d-flex justify-content-start align-items-center",
                            },
                            [
                              _c("label", { attrs: { for: "trustedDevice" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("account.trustThisDeviceStatement")
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "text-center p-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "simple-button",
                            {
                              staticClass: "w-100 bold",
                              attrs: {
                                id: "send-code-mfa",
                                "button-type": "submit",
                                type: "primary",
                                loading: _vm.sendingMfaCode,
                                "loading-succeeded": _vm.mfaCodeDelivered,
                              },
                              on: { click: _vm.validateMfaAndSignIn },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("account.validateMfaButtonText")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "b-col",
            [
              _c(
                "b-row",
                { staticClass: "mt-5" },
                [
                  _c("b-col", { staticClass: "text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("account.enhancedSecurityText")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-5" },
                [
                  _c("b-col", {}, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("account.mfaVerificationInstructions")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        { staticClass: "d-flex flex-row" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "10" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center align-items-center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedMethodMfa,
                                                    expression:
                                                      "selectedMethodMfa",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "select-email-mfa",
                                                  type: "radio",
                                                  name: "add-client-option",
                                                  value: "sms",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.selectedMethodMfa,
                                                    "sms"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.selectedMethodMfa =
                                                      "sms"
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "material-input",
                                                {
                                                  attrs: {
                                                    id: "phoneNumber",
                                                    label: _vm.$t(
                                                      "account.phoneNumber"
                                                    ),
                                                    "required-indicator": "",
                                                    disabled:
                                                      _vm.selectedMethodMfa ===
                                                      "email",
                                                  },
                                                  model: {
                                                    value: _vm.phoneNumber,
                                                    callback: function ($$v) {
                                                      _vm.phoneNumber = $$v
                                                    },
                                                    expression: "phoneNumber",
                                                  },
                                                },
                                                [
                                                  _c("phone-input", {
                                                    attrs: {
                                                      name: "phoneNumber",
                                                      placeholder: _vm.$t(
                                                        "account.phoneNumber"
                                                      ),
                                                      type: "text",
                                                      title: _vm.$t(
                                                        "account.phoneNumber"
                                                      ),
                                                      "data-lpignore": "true",
                                                      "emit-value": true,
                                                      value: _vm.phoneNumber,
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.updateEnableSendCodeButton,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center align-items-center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedMethodMfa,
                                                    expression:
                                                      "selectedMethodMfa",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "select-email-mfa",
                                                  type: "radio",
                                                  name: "add-client-option",
                                                  value: "email",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.selectedMethodMfa,
                                                    "email"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.selectedMethodMfa =
                                                      "email"
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "flex-column align-items-start justify-content-center",
                                                attrs: { for: "begin-an-app" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bold text-light-gray",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "account.email"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-block text-light-gray",
                                                  },
                                                  [_vm._v(_vm._s(_vm.mfaEmail))]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex vertical-center",
                              attrs: { cols: "2" },
                            },
                            [
                              _c(
                                "simple-button",
                                {
                                  staticClass: "bold",
                                  attrs: {
                                    id: "send-code-mfa",
                                    disabled: !_vm.enableSendCodeButton,
                                    "button-type": "submit",
                                    type: "primary",
                                    loading: _vm.sendingMfaCode,
                                    "loading-succeeded": _vm.mfaCodeDelivered,
                                  },
                                  on: { click: _vm.updateUserMfa },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("account.sendCode")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.mfaPreferences.mfaSnoozeRemaining >= 1
                        ? _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("account.mfaSnoozeText", {
                                        count:
                                          _vm.mfaPreferences.mfaSnoozeRemaining,
                                      })
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mfaPreferences.mfaSnoozeRemaining >= 1
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { staticClass: "mt-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "bold underline text-primary d-block d-md-inline",
                                    staticStyle: { cursor: "pointer" },
                                    on: { click: _vm.snoozeMfaSetup },
                                  },
                                  [_vm._v("SNOOZE")]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }